<template>
   <div class="business">
        <h2>业务范围</h2>
        <div class="business-swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="item in businessInfo" :key="item.id">
                    <p v-html="item.content"></p>
                    <img :src="$imgUrl+item.icon" alt="">
                    <br>
                    <img :src="$imgUrl+item.images" alt="">
                    <h4>{{item.title}}</h4>
                </div>
            </div>
            <div class="swiper-pagination"></div>
            <div class="business-swiper-button-next"><i class="iconfont icon-icon_arrow_right"></i></div>
            <div class="business-swiper-button-prev"><i class="iconfont icon-jiantouzuo"></i></div>
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper'
export default {
    name: 'Data',
    props:{
        businessInfo: Array
    },
    data () {
        return {
        }
    },
    mounted () {
        // this.imgSwiper()
    },
    methods: {
        imgSwiper () {
            var swiper = new Swiper('.business-swiper-container', {
                slidesPerView: 1,
                pagination: {
                    el: '.swiper-pagination',
                    // clickable: true,
                    type: 'custom',
                    renderCustom (swiper, current, total) {
                        var customPaginationHtml = "";
                        for(var i = 0; i < total; i++) {
                            //判断哪个分页器此刻应该被激活
                            if(i == (current - 1)) {
                                customPaginationHtml += '<span class="swiper-pagination-customs swiper-pagination-customs-active"></span>';
                            } else {
                                customPaginationHtml += '<span class="swiper-pagination-customs"></span>';
                            }
                        }
                        return customPaginationHtml;
                    }
                },
                hiddenClass: 'my-button-hidden',
                navigation: {
                    nextEl: '.business-swiper-button-next',
                    prevEl: '.business-swiper-button-prev',
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import '~styles/varible.styl'
    @import '~styles/mixins.styl'
    .business-swiper-container >>> .swiper-pagination-custom 
                                        bottom: 7%
                                        left: 0
                                        width: 100%
                                        .swiper-pagination-customs
                                            display: inline-block
                                            width: 0.4rem
                                            height: 0.02rem
                                            background: #fff
                                            margin: 0 0.06rem
                                            border-radius: 0.04rem
                                            opacity: 0.5
                                        .swiper-pagination-customs-active
                                            background-color: $yellow
                                            height: 0.04rem
                                            opacity: 1
                                    .swiper-button-disabled
                                        opacity: 0.4
    .business-swiper-container >>> .swiper-slide
                                        >p
                                            *
                                                font-family: MicrosoftYaHei !important
                                                font-size: 0.28rem !important

    .business
        position: relative
        padding: 0.86rem 5% 0
        text-align: center
        background-image: url("../../static/images/m_home_business.png")
        background-size: 100% 105%
        h2
            display:inline-block
            margin: 0 auto
            color: #fff
            position: relative
            font-size: 0.4rem
            letter-spacing: 1px
            font-weight: 1000
            margin-bottom: 29px
            &:after
                position: absolute
                display: block
                content: ''
                bottom: 0 
                right: -0.14rem
                width: 0.34rem
                height: 0.08rem
                background: $yellow
                border-radius: 0.05em
                opacity: 0.8
        .business-swiper-container
            position: relative
            overflow: hidden
            padding-bottom: 20%
            .swiper-slide
                position: relative
                >p
                    text-align: left
                    color: #fff
                    line-height: 1.4em
                    letter-spacing: 1px
                    height: 7em
                    text-ellipsis()
                    -webkit-line-clamp: 5
                img:first-of-type
                    width:23%
                    margin-top: 52px
                    transform: scale(1.3)
                img:last-of-type
                    position: relative
                    z-index: 10
                    margin-top: -2%
                    width: 66%
                h4
                    margin-top: 0.5rem
                    color: #dadada
                    font-size: 0.32rem
                    font-weight: 400
                    color: $yellow
        .business-swiper-button-next
            position: absolute
            color: #fff
            z-index: 3
            right: 0
            top: 50%
            cursor: pointer
            i
                font-size: 0.3rem
        .business-swiper-button-prev
            position: absolute
            color: #fff
            left: 0
            z-index: 3
            top: 50%
            cursor: pointer
            i
                font-size: 0.3rem
</style>


// WEBPACK FOOTER //
// src/components/mobile/HomeBusiness.vue